import { defineFeatures } from "../define-provider-capability";

/**
 * The `eas` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const easMobileFeatures = defineFeatures({
  // Mobile EAS project id, baked into the JS bundle at build time.
  mobileProject: {
    scope: "runtime",
    environments: {
      local: { mode: "managed" },
      preview: { mode: "managed" },
      production: { mode: "managed" },
    },
    env: [
      {
        name: "EXPO_PUBLIC_EAS_PROJECT_ID",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "environment" },
      },
    ],
  },
});
